import { render, staticRenderFns } from "./ResumeManagement.vue?vue&type=template&id=5274525b&scoped=true&"
import script from "./ResumeManagement.vue?vue&type=script&lang=js&"
export * from "./ResumeManagement.vue?vue&type=script&lang=js&"
import style0 from "./ResumeManagement.vue?vue&type=style&index=0&id=5274525b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5274525b",
  null
  
)

export default component.exports